export default __webpack_public_path__ + "static/media/featuredPosts-shape.5e1d7024.svg";